export default __webpack_public_path__ + "static/media/KK_R_Left_Bottom_sCrop.cf23fba7.svg";